/** Region of the product mockup showing this bonus cover, as fractions of the image (0–1). */
export interface CoverCrop {
  x: number
  y: number
  w: number
  h: number
}

export interface Bonus {
  number: string
  title: string
  intro?: string
  /** Label shown in front of the item list. */
  listLabel?: string
  items?: string[]
  /** Optional label in front of the closing lines (e.g. "Result:"). */
  closingLabel?: string
  closing: string[]
  /** Label color from the bonus covers in the mockup. */
  color: string
  /** Where the cover sits inside the product mockup. */
  crop: CoverCrop
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'The 5-Minute Practice Builder™',
    intro:
      'Answer a few simple questions and quickly build a clear practice structure.',
    listLabel: 'Choose:',
    items: [
      'Age group',
      'Main goal',
      'Time available',
      'Number of players',
      'Court space',
      'Equipment',
      'Skill priority',
    ],
    closingLabel: 'Result:',
    closing: ['A simple practice structure you can organize in minutes.'],
    color: '#f97316',
    crop: { x: 0.036, y: 0.69, w: 0.208, h: 0.255 },
  },
  {
    number: '2',
    title: 'No-Lines Game Bank™',
    intro:
      'A collection of games designed to keep more players moving and reduce waiting time.',
    listLabel: 'Use them for:',
    items: [
      'Warm-ups',
      'Ball handling',
      'Passing',
      '1v1',
      '2v2',
      'Reaction',
      'Competition',
      'Decision-making',
    ],
    closing: ['Less waiting.', 'More touches.', 'More engagement.'],
    color: '#3b82f6',
    crop: { x: 0.232, y: 0.69, w: 0.186, h: 0.255 },
  },
  {
    number: '3',
    title: 'Coaching Cue Cheat Sheets™',
    listLabel: 'Short, useful coaching cues for:',
    items: [
      'Dribbling',
      'Passing',
      'Shooting',
      'Finishing',
      'Defense',
      'Rebounding',
      'Movement',
      'Spacing',
      'Decision-making',
    ],
    closing: ['Less talking.', 'Clearer corrections.', 'More repetitions.'],
    color: '#14b8a6',
    crop: { x: 0.418, y: 0.69, w: 0.18, h: 0.255 },
  },
  {
    number: '4',
    title: 'Small Space / Low Equipment Playbook™',
    listLabel: 'Solutions for practices with:',
    items: [
      'One basket',
      'Half a court',
      'Few basketballs',
      'Large groups',
      'Limited cones',
      'Mixed ability levels',
    ],
    closing: ['Keep the session moving even when conditions are not perfect.'],
    color: '#ef4444',
    crop: { x: 0.602, y: 0.69, w: 0.184, h: 0.255 },
  },
  {
    number: '5',
    title: 'Drill Fixer™',
    intro: 'What should you change when a drill is not working?',
    listLabel: 'Quick adjustments for:',
    items: [
      'Too easy',
      'Too hard',
      'Too much waiting',
      'Players losing focus',
      'Too much space',
      'Too little space',
      'Confusion',
      'Low intensity',
      'Not enough decisions',
      'Mixed ability levels',
    ],
    closing: ['Instead of replacing the entire drill, change one variable at a time.'],
    color: '#8b5cf6',
    crop: { x: 0.786, y: 0.69, w: 0.2, h: 0.255 },
  },
]
